import React, { useState } from 'react';
import { IUser } from '@interfaces/IUser';
import { IDataTableSort } from '@interfaces/IDataTableSort';
import { ColumnConfig, DataTable, Text } from 'grommet';
import UserManageOptions from './UserManageOptions/UserManageOptions';

export interface ManageUsersDataTableProps {
  users: IUser[];
  refreshData: () => void;
}

const ManageUsersDataTable: React.FC<ManageUsersDataTableProps> = ({ users }): JSX.Element => {
  const [sort, setSort] = useState<IDataTableSort>({
    property: 'Title',
    direction: 'desc',
  });

  const columns: ColumnConfig<IUser>[] = [
    {
      property: 'LastName',
      primary: false,
      search: false,
      sortable: false,
      header: 'Name',
      render: (datum: IUser): React.ReactNode => (
        <UserManageOptions
          user={datum}
        />
      ),
    },
    {
      property: 'NickName',
      primary: false,
      search: false,
      sortable: false,
      header: 'Nickname',
      render: (datum: IUser): React.ReactNode => (
        <Text>{datum.NickName}</Text>
      ),
    },
    {
      property: 'IsOwner',
      primary: false,
      search: false,
      sortable: true,
      header: 'Is Owner?',
      render: (datum: IUser): React.ReactNode => (
        <Text>{(datum.IsOwner) ? 'Yes' : 'No'}</Text>
      ),
    },
    {
      property: 'Validated',
      primary: false,
      search: false,
      sortable: true,
      header: 'Validated?',
      render: (datum: IUser): React.ReactNode => (
        <Text>{(datum.Validated) ? 'Yes' : 'No'}</Text>
      ),
    },
    {
      property: 'Active',
      primary: false,
      search: false,
      sortable: true,
      header: 'Is Active?',
      render: (datum: IUser): React.ReactNode => (
        <Text>{(datum.Active) ? 'Yes' : 'No'}</Text>
      ),
    },
    {
      property: 'DoNotContact',
      primary: false,
      search: false,
      sortable: true,
      header: 'Do Not Contact?',
      render: (datum: IUser): React.ReactNode => (
        <Text>{(datum.DoNotContact) ? 'True' : 'False'}</Text>
      ),
    },
    {
      property: 'Guid',
      primary: true,
      search: false,
      sortable: false,
      header: 'Quick Actions',
      render: (datum: IUser): React.ReactNode => (
        // <ManageUsersActions
        //   user={datum}
        //   refreshData={refreshData}
        // />
        <>{datum.Guid}</>
      ),
    },
  ];

  return (
    <DataTable
      fill="horizontal"
      data={users}
      background={{
        body: ['background', 'background-front'],
      }}
      border={{
        body: 'bottom',
      }}
      sortable={false}
      sort={sort}
      onSort={setSort}
      pad={{
        horizontal: 'small',
        vertical: 'xsmall',
      }}
      rowProps={{
        true: {
          background: 'dark-brand',
        },
      }}
      columns={columns}
    />
  );
};

ManageUsersDataTable.displayName = 'ManageUsersDataTable';

export default ManageUsersDataTable;
